import "./CustomCard.scss";

const CustomCard = ({ children, className = "" }) => {
  return (
    <div className={`custom-card-container ${className}`}>
      {children}
    </div>
  );
};

export default CustomCard;
